/* maris — scratch popup. Vanilla, self-contained, no dependencies. */
(function () {
  var root = document.getElementById('mxsp');
  if (!root) return;

  var KEY_DONE = 'maris_popup_done';
  var KEY_CLOSED = 'maris_popup_closed_at';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var days = parseInt(root.dataset.days, 10) || 14;
  var delay = (parseInt(root.dataset.delay, 10) || 5) * 1000;
  var code = root.dataset.code || 'WELCOME10';

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  if (read(KEY_DONE)) return;
  var closedAt = parseInt(read(KEY_CLOSED), 10);
  if (closedAt && Date.now() - closedAt < days * 864e5) return;

  var modal = root.querySelector('.mxsp__modal');
  var stageScratch = root.querySelector('[data-mxsp-stage="scratch"]');
  var stageEmail = root.querySelector('[data-mxsp-stage="email"]');
  var stageCode = root.querySelector('[data-mxsp-stage="code"]');
  var form = root.querySelector('#mxsp-form');
  var email = root.querySelector('#mxsp-email');
  var error = root.querySelector('#mxsp-error');
  var card = root.querySelector('.mxsp__card');
  var canvas = root.querySelector('[data-mxsp-canvas]');
  var lastFocus = null;

  /* ---- open / close ---- */
  /* iOS-proof body scroll lock: fixed-position body, restore scroll on close */
  var savedScroll = 0;
  function lockBody() {
    savedScroll = window.scrollY || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = -savedScroll + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBody() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScroll);
  }

  var scratchReady = false;
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    lockBody();
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      if (!scratchReady) { scratchReady = true; initScratch(); }
    });
    modal.focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (!read(KEY_DONE)) store(KEY_CLOSED, String(Date.now()));
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    unlockBody();
    var end = function () { root.hidden = true; };
    reduced ? end() : setTimeout(end, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var els = modal.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    var list = Array.prototype.filter.call(els, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }
  root.querySelectorAll('[data-mxsp-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      /* once the code is on screen, only the explicit × closes the popup */
      if (root.dataset.stage === 'code' && !el.classList.contains('mxsp__x')) return;
      close();
    });
  });

  if (document.readyState === 'complete') setTimeout(open, delay);
  else window.addEventListener('load', function () { setTimeout(open, delay); });

  /* ---- flow: scratch (won) -> email -> code ---- */
  function finish() {
    if (card.classList.contains('is-done')) return;
    card.classList.add('is-done');
    var reveal = root.querySelector('[data-mxsp-reveal]');
    if (reveal) reveal.hidden = true;
    /* card stays visible showing the win; email step appears below it */
    stageEmail.hidden = false;
    if (email) email.focus();
  }

  function toCode() {
    store(KEY_DONE, '1');
    /* arm checkout: Shopify's /discount/CODE route sets the discount cookie, so the
       code applies automatically at checkout — only ever fired here, i.e. only after
       the scratch is done AND a valid email was submitted */
    try { fetch('/discount/' + encodeURIComponent(code)).catch(function () {}); } catch (e) {}
    root.dataset.stage = 'code';
    stageScratch.hidden = true;
    stageEmail.hidden = true;
    stageCode.hidden = false;
    var copy = root.querySelector('[data-mxsp-copy]');
    if (copy) copy.focus();
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  form.addEventListener('submit', function (e) {
    /* stop the theme's global form/navigation handlers from hijacking the submit */
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var v = email.value.trim();
    if (!validEmail(v)) {
      error.hidden = false;
      email.setAttribute('aria-invalid', 'true');
      email.focus();
      return;
    }
    error.hidden = true;
    email.removeAttribute('aria-invalid');
    var btn = form.querySelector('.mxsp__btn');
    btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .catch(function () { /* network hiccup — still show the code; Shopify dedupes on retry */ })
      .then(toCode);
  });
  email.addEventListener('input', function () { error.hidden = true; email.removeAttribute('aria-invalid'); });

  function initScratch() {
    if (!canvas || !canvas.getContext) { finish(); return; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = card.clientWidth, h = card.clientHeight;
    canvas.width = w * dpr; canvas.height = h * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    /* overlay: cream field, faint star lattice, SCRATCH HERE */
    var overlay = getComputedStyle(root).getPropertyValue('--mxsp-scratch').trim() || '#E9E3D0';
    ctx.fillStyle = overlay;
    ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = 'rgba(168, 135, 63, .18)';
    ctx.font = '13px serif';
    for (var y = 10; y < h; y += 34) {
      for (var x = ((y / 34) % 2) * 17 + 8; x < w; x += 34) { ctx.fillText('✦', x, y); }
    }
    ctx.fillStyle = 'rgba(38, 36, 31, .55)';
    ctx.font = '500 11px monospace';
    ctx.textAlign = 'center';
    var label = 'S C R A T C H   H E R E';
    ctx.fillText(label, w / 2, h / 2 + 4);

    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineWidth = 34;
    ctx.lineCap = ctx.lineJoin = 'round';

    var drawing = false, lastX = 0, lastY = 0, strokes = 0;
    function pt(e) {
      var t = e.touches && e.touches[0] ? e.touches[0] : e;
      var r = canvas.getBoundingClientRect();
      return [t.clientX - r.left, t.clientY - r.top];
    }
    function check() {
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var clear = 0, total = data.length / 4;
      for (var i = 3; i < data.length; i += 16) { if (data[i] === 0) clear++; }
      if (clear / (total / 4) > 0.5) finish();
    }
    function start(e) {
      if (card.classList.contains('is-locked')) return;
      drawing = true;
      var p = pt(e); lastX = p[0]; lastY = p[1];
      /* scratch a dot on tap so single touches also register */
      ctx.beginPath(); ctx.moveTo(lastX, lastY); ctx.lineTo(lastX + 0.1, lastY + 0.1); ctx.stroke();
      if (e.pointerId !== undefined && canvas.setPointerCapture) {
        try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (e.cancelable) e.preventDefault();
    }
    function move(e) {
      if (!drawing) return;
      var p = pt(e);
      ctx.beginPath(); ctx.moveTo(lastX, lastY); ctx.lineTo(p[0], p[1]); ctx.stroke();
      lastX = p[0]; lastY = p[1];
      if (++strokes % 14 === 0) check();
      if (e.cancelable) e.preventDefault();
    }
    function end() { if (drawing) { drawing = false; check(); } }

    if (canvas.dataset.bound) return;
    canvas.dataset.bound = '1';

    /* hard-stop iOS page scrolling for any touch on the card, on every code path */
    canvas.addEventListener('touchstart', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    canvas.addEventListener('touchmove', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });

    if (window.PointerEvent) {
      canvas.addEventListener('pointerdown', start);
      canvas.addEventListener('pointermove', move);
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        canvas.addEventListener(ev, end);
      });
    } else {
      canvas.addEventListener('touchstart', start, { passive: false });
      canvas.addEventListener('touchmove', move, { passive: false });
      canvas.addEventListener('touchend', end);
      canvas.addEventListener('mousedown', start);
      canvas.addEventListener('mousemove', move);
      canvas.addEventListener('mouseup', end);
      canvas.addEventListener('mouseleave', end);
    }
  }

  var revealBtn = root.querySelector('[data-mxsp-reveal]');
  if (revealBtn) revealBtn.addEventListener('click', finish);

  /* ---- copy code ---- */
  var copyBtn = root.querySelector('[data-mxsp-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var done = function () {
      var was = copyBtn.textContent;
      copyBtn.textContent = 'Code copied';
      setTimeout(function () { copyBtn.textContent = was; }, 2200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else { done(); }
  });
})();
